{
  "wave": {
    "name": "Wave",
    "description": "Fey bu gaaw ci Wave",
    "instructions": "Dinga jot notification Wave ngir dëggal fey bi",
    "ussd_prompt": "Tonal *1* ngir dëggal"
  },
  "orange_money": {
    "name": "Orange Money",
    "description": "Fey ci Orange Money",
    "instructions": "Tonal #144# ngir dëggal fey bi",
    "ussd_prompt": "Duggal sa code secret Orange Money"
  },
  "cash_on_delivery": {
    "name": "Fey ci jëlëg",
    "description": "Fey ci xaalis bu ñu la indil sa komand"
  },
  "status": {
    "pending": "Ngi xaar fey bi",
    "processing": "Ci kanam",
    "confirmed": "Fey bi dëgg na",
    "failed": "Fey bi jotul",
    "timeout": "Waxtu bi jeex na",
    "refunded": "Xaalis bi dellu na"
  },
  "errors": {
    "network": "Njuumte ci connexion bi. Xoolal sa réseau.",
    "invalid_phone": "Nimero telefon bi baaxul",
    "insufficient_funds": "Solde bi doyul",
    "provider_unavailable": "Service bi nëkku ci waxtu bii",
    "invalid_amount": "Montant bi baaxul",
    "timeout": "Waxtu bi jeex na. Jéemal ko.",
    "unknown": "Am na njuumte bu amatul"
  },
  "actions": {
    "retry": "Jéemal ko",
    "cancel": "Neenal fey bi",
    "change_method": "Soppi yoonu fey bi"
  }
}
